import Link, { LinkProps } from 'next/link';
import { useRouter } from 'next/router';

import { useOasApp } from '@/providers';

type ModuleLinkProps = {
  href: string;
  className?: string;
} & React.HTMLAttributes<HTMLAnchorElement> &
  LinkProps;

const LOCATION_SEGMENTS_COUNT = 3;

export const ModuleLink: React.FC<ModuleLinkProps> = ({
  href,
  children,
  className,
  ...props
}: ModuleLinkProps) => {
  const { isLocation, dotcms, scSiteCookie } = useOasApp();
  const router = useRouter();
  const currentPath = router.asPath;

  const urlSegments = currentPath.split('/').filter((value) => value);
  const locationPath = urlSegments.slice(0, LOCATION_SEGMENTS_COUNT).join('/');
  const isDotcms = scSiteCookie === 'dotcms' || dotcms?.dotCmsHostId;

  if (isLocation && isDotcms) {
    const urlWithLocationPrefix = `${locationPath}${href}`;

    return (
      <Link href={urlWithLocationPrefix} className={className} {...props}>
        {children}
      </Link>
    );
  }

  // we need to use anchor tags with location pages since we cant use next/link
  return isLocation && !isDotcms ? (
    <a href={href} className={className} {...props}>
      {children}
    </a>
  ) : (
    <Link href={href} className={className} {...props}>
      {children}
    </Link>
  );
};
